import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeStyle as _normalizeStyle, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createBlock as _createBlock, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "wp1200" }
const _hoisted_2 = { class: "title" }
const _hoisted_3 = { class: "sliderEvent news" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "swiper-pagination" }, null, -1)
const _hoisted_5 = { class: "product-item" }
const _hoisted_6 = { class: "product-item-content" }
const _hoisted_7 = { class: "content" }
const _hoisted_8 = { class: "date" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("i", { class: "warpit_icon_arrow-R" }, null, -1)
const _hoisted_10 = { class: "linkButton" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("i", { class: "warpit_icon_arrow-R" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_swiper_slide = _resolveComponent("swiper-slide")!
  const _component_swiper = _resolveComponent("swiper")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("h3", _hoisted_2, _toDisplayString(_ctx.$t("news_slider.title")), 1),
    _createElementVNode("div", _hoisted_3, [
      _createVNode(_component_swiper, {
        breakpoints: _ctx.breakpoints,
        modules: _ctx.modules,
        pagination: { el: 'swiper-pagination', clickable: true }
      }, {
        default: _withCtx(() => [
          _hoisted_4,
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.news.data, (article) => {
            return (_openBlock(), _createBlock(_component_swiper_slide, {
              key: article.id
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_5, [
                  _createElementVNode("div", _hoisted_6, [
                    _createVNode(_component_router_link, {
                      to: { name: 'Article', params: { id: article.id } },
                      class: "newsCard"
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("div", {
                          class: "newsImage",
                          style: _normalizeStyle({
                    backgroundImage: 'url(' + article.image_url + ')',
                  })
                        }, null, 4),
                        _createElementVNode("div", _hoisted_7, [
                          _createElementVNode("h2", null, _toDisplayString(article.title), 1),
                          _createElementVNode("span", _hoisted_8, _toDisplayString(_ctx.$moment(article.datetime).format("DD.MM.yyyy")), 1),
                          _createElementVNode("p", null, _toDisplayString(article.summary), 1)
                        ]),
                        _hoisted_9
                      ]),
                      _: 2
                    }, 1032, ["to"])
                  ])
                ])
              ]),
              _: 2
            }, 1024))
          }), 128))
        ]),
        _: 1
      }, 8, ["breakpoints", "modules"]),
      _createElementVNode("div", _hoisted_10, [
        _createVNode(_component_router_link, {
          class: "showAllLink",
          to: { name: 'News' }
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.$t("news_slider.all")) + " ", 1),
            _hoisted_11
          ]),
          _: 1
        })
      ])
    ])
  ]))
}